export const accommodationPracticalBlock = {
  PRACTICAL_BLOCK_DESCRIPTION_TOGGLED: 'accommodationPracticalBlock.description'
}
